<template>
  <div>
    <div v-if="loadComplete">
      <div class="container-fluid mt-3">
        <!-- THIS ROW SHOWS STATS ONLY ON DESKTOP due to d-none / d-flex breakpoints -->
        <div class="row d-none d-xl-flex">
          <div class="col-xl-3 col-md-6">
              <stat-card
                title="# of Jobs"
                type="gradient-blue"
                :sub-title="jobCount.toString()"
                icon="img-icon img-icon-jobs-nav"
                :link-url="jobsUrl">
              </stat-card>
          </div>
          <div class="col-xl-3 col-md-6">
            <stat-card
                title="# of Media Items"
                type="gradient-blue"
                :sub-title="mediaCount.toString()"
                icon="img-icon img-icon-media-nav"
                :link-url="mediaUrl">
            </stat-card>
          </div>
          <div class="col-xl-3 col-md-6">
            <stat-card
                title="Space Used"
                type="gradient-blue"
                :sub-title="byteCount | bytes"
                icon="img-icon img-icon-design-3"
                :link-url="storageUrl">
            </stat-card>
          </div>
          <div class="col-xl-3 col-md-6">
            <stat-card
                title="Files & Folders"
                type="gradient-blue"
                :sub-title="(fileCount + folderCount).toString()"
                icon="img-icon img-icon-document-copy-2"
                :link-url="filesUrl">
            </stat-card>
          </div>
        </div>
        <div class="row">
<!--          <div class="col-xl-4 col-md-6">-->
<!--            <project-users-list></project-users-list>-->
<!--          </div>-->
          <b-col>
            <job-list-group></job-list-group>
          </b-col>
          <b-col>
            <entity-list-group></entity-list-group>
          </b-col>
          <b-col>
            <manifest-list-group></manifest-list-group>
          </b-col>
        </div>
        <!-- Live Cards -->
        <!-- <div class="row">
          <div class="col-xl-12">
            <job-search-card />
          </div>
          <div class="col-xl-4">
            <media-search-card />
          </div>
        </div> -->
      </div>
    </div>
    <div v-else>Loading...</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import StatCard from '#/ui/Components/StatCard.vue';
import JobListGroup from '#/ui/Components/JobListGroup.vue';
import EntityListGroup from '#/ui/Components/Entities/EntityListGroup.vue';
import ManifestListGroup from '#/ui/Components/Manifest/ManifestListGroup.vue';

export default {
  components: {
    JobListGroup,
    EntityListGroup,
    StatCard,
    ManifestListGroup,
  },
  computed: {
    ...mapGetters({
      loadComplete: 'isInitialLoadComplete',
      jobCount: 'activeProjectJobCount',
      mediaCount: 'activeProjectMediaCount',
      byteCount: 'activeProjectByteCount',
      fileCount: 'activeProjectFileCount',
      folderCount: 'activeProjectFolderCount',
    }),
    jobsUrl() {
      return '/jobs';
    },
    mediaUrl() {
      return '/media';
    },
    filesUrl() {
      // TODO: change to files route once exists
      return '/media';
    },
    storageUrl() {
      const wId = this.$store.getters.activeWorkspaceId;
      if (wId) {
        return `/workspace/${wId}/storage`;
      }
      return undefined;
    },
  },
  methods: {
  },
  created() {
    // this.$store.dispatch('live/beginProjectStream');
  },
  beforeDestroy() {
    // this.$store.commit('live/killRunLoop');
  },
};
</script>
<style> 

</style>